<template>
  <div class="order">
    <search @handleSearch="handleSearch" />
    <el-tabs
      v-model="activeName"
      class="tabs-container"
      @tab-click="handleClick"
    >
      <el-tab-pane label="全部" name="all"></el-tab-pane>
      <el-tab-pane label="未读" name="0"></el-tab-pane>
      <el-tab-pane label="已读" name="1"></el-tab-pane>
    </el-tabs>
    <div class="table-container">
      <div class="table-btn">
        <el-button
          type="text"
          size="mini"
          @click="handleAlready('selected')"
          :loading="btnLoading"
          icon="el-icon-document-checked"
          >标为已读</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleAlready('all')"
          :loading="btnLoading"
          icon="el-icon-folder-checked"
          >全部已读</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleDelete('selected')"
          :loading="btnLoading"
          icon="el-icon-delete"
          >批量删除</el-button
        >
      </div>
      <el-table
        ref="messageTable"
        row-key="messageId"
        :data="tableData"
        border
        stripe
        v-loading="loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="40"
          align="center"
        >
        </el-table-column>
        <el-table-column type="index" label="序号" width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="messageContentzh"
          label="通知内容"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="messageType"
          label="类型"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.messageType === 0 ? "驳回" : "" }}
            {{ scope.row.messageType === 1 ? "拒赔" : "" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="接收时间"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop=""
          label="状态"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.messageStatus === 0 ? "未读" : "已读" }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="180px"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="toDetail(scope.row)"
              >查看索赔单</el-button
            >
            <el-button
              v-if="scope.row.messageStatus === 0"
              size="mini"
              type="text"
              @click="handleAlready('single', scope.row)"
              >标为已读</el-button
            >
            <el-button
              size="mini"
              type="text"
              @click="handleDelete('single', scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye" v-show="total > 0">
        <pagination
          :total="total"
          :page.sync="page"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { messageList, messageReading, messageDelete } from "@/api/seek";
import search from "@/components/messageCenterSearch";
import { setStorageNew } from "@/util/localStor";

export default {
  components: {
    search
  },
  data() {
    return {
      activeName: "all",
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      searchInfo: {},
      loading: false,
      btnLoading: false,
      ids: []
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.messageId);
    },
    // 搜索
    handleSearch(data) {
      this.page = 1;
      this.pageSize = 10;
      this.searchInfo.messageContentzh = data.messageContent;
      this.searchInfo.messageType = data.messageType;
      this.searchInfo.messageStatus =
        this.activeName === "all" ? "" : this.activeName;
      if ((data.createTime || []).length === 2) {
        this.searchInfo.createTimeStart = data.createTime[0] + " 00:00:00";
        this.searchInfo.createTimeEnd = data.createTime[1] + " 23:59:59";
      } else {
        this.searchInfo.createTimeStart = "";
        this.searchInfo.createTimeEnd = "";
      }
      delete data.createTime;
      this.getList();
    },
    // 切换tab
    handleClick(tab) {
      this.page = 1;
      this.pageSize = 10;
      this.searchInfo.messageStatus = tab.name === "all" ? "" : tab.name;
      this.getList();
    },
    // 获取列表
    async getList() {
      this.loading = true;
      let query = {
        data: {
          ...this.searchInfo
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize
        }
      };
      const res = await messageList(query);
      if (res.status == 0) {
        this.tableData = res.data?.records;
        this.total = res.data?.count;
        this.loading = false;
      }
    },
    // 分页
    handlePaginationChange(val) {
      this.page = val.page;
      this.pageSize = val.limit;
      this.getList();
    },
    toDetail(row) {
      setStorageNew("claimantData", {});
      this.$router.push({
        path: "/claimant/preDetail",
        query: {
          messageId: row.messageId,
          claimantId: row.dataId,
          messageStatus: row.messageStatus
        }
      });
    },
    // 标为已读
    async handleAlready(type, row) {
      var res = {};
      if (type === "selected" && !(this.ids && this.ids.length > 0)) {
        this.$DonMessage.warning("请选择");
        return;
      }
      this.loading = true;
      if (type === "selected") {
        res = await messageReading({ data: { messageList: this.ids } });
      }
      if (type === "all") {
        res = await messageReading({ data: { messageList: [] } });
      }
      if (type === "single") {
        res = await messageReading({ data: { messageList: [row.messageId] } });
      }
      this.loading = false;
      if (res.status == 0) {
        this.$DonMessage.success("操作成功");
        this.getList();
        this.$refs.messageTable.clearSelection();
      } else {
        this.$DonMessage.error(res.message);
      }
    },
    // 删除
    async handleDelete(type, row) {
      var res = {};
      if (type === "selected" && !(this.ids && this.ids.length > 0)) {
        this.$DonMessage.warning("请选择");
        return;
      }
      this.loading = true;
      if (type === "selected") {
        res = await messageDelete({ data: { messageList: this.ids } });
      }
      if (type === "single") {
        res = await messageDelete({ data: { messageList: [row.messageId] } });
      }
      this.loading = false;
      if (res.status == 0) {
        this.$DonMessage.success("操作成功");
        this.getList();
        this.$refs.messageTable.clearSelection();
      } else {
        this.$DonMessage.error(res.message);
      }
    }
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
